let cachedLibraries = {};

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('LibrariesAPIService', librariesAPIService);

    function librariesAPIService(HttpService) {
        function getLibraries(args) {
            const { searchString, from, num, type, deleted = false, excludeLibrariesWithCategories = false } = args;
            var data = {
                searchString: searchString,
                from: from,
                num: num,
                type: type,
                deleted: deleted,
                excludeLibrariesWithCategories: excludeLibrariesWithCategories
            };
            return HttpService.get('/Libraries?' + $.param(data));
        }

        function getLibrariesCount(args) {
            const { searchString, type, deleted = false, excludeLibrariesWithCategories = false } = args;
            var data = {
                searchString: searchString,
                type: type,
                deleted: deleted,
                excludeLibrariesWithCategories: excludeLibrariesWithCategories
            };
            return HttpService.get('/Libraries/Count?' + $.param(data));
        }

        async function getLibraryElementAtPosition(libraryId, elementPosition) {
            if (!libraryId || !elementPosition) {
                return null;
            }

            const cachedElement = cachedLibraries[`${libraryId}-${elementPosition}`];
            if (cachedElement) {
                return cachedElement;
            }

            return HttpService.get('/Libraries/' + libraryId + '/Elements/Position/' + elementPosition + '/Private');
        }

        async function getLibrariesElementAtPosition(payload) {
            if (!payload?.libraryIds?.length) {
                return;
            }

            const response = await HttpService.put('/Libraries/Elements/Private', payload);
            cachedLibraries = { ...cachedLibraries, ...response.reduce((acc, element) => {
                acc[`${element.Library_LibraryId}-${element.position}`] = element;
                return acc;
            }, {}) };
        }

        function getLibraryName(libraryId) {
            return HttpService.get('/Libraries/' + libraryId + '/Name');
        }

        function clearCachedLibraries() {
            cachedLibraries = {};
        }

        function extractLibraryIdsFromElement(element, libraryIdKeys) {
            const libraryIds = [];
            for (const key of libraryIdKeys) {
                if (element[key]) {
                    libraryIds.push(element[key]);
                }
            }
            return libraryIds;
        }

        function extractLibraryIdsFromElements(elements, libraryIdKeys) {
            const libraryIds = [];
            for (const element of elements) {
                libraryIds.push(...extractLibraryIdsFromElement(element, libraryIdKeys));
            }
            return libraryIds;
        }

        function getLibraryPositionsFromListEps(listEps) {
            if (!listEps || !Array.isArray(listEps)) {
                return undefined;
            }

            const libraries = [];

            const elementTypeConfigs = [
                {
                    key: 'textsEps',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId', 'strokeColorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'circularTextsEps',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId']
                },
                {
                    key: 'imagePlaceHoldersEps',
                    libraryIdKeys: ['imageLibraryId', 'colorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'vectorEPSEps',
                    libraryIdKeys: ['vectorLibraryId', 'colorLibraryId']
                }
            ];

            for (const eps of listEps) {
                for (const config of elementTypeConfigs) {
                    const elements = eps[config.key] || [];
                    libraries.push(...extractLibraryIdsFromElements(elements, config.libraryIdKeys));
                }
            }

            const uniqueLibraries = [...new Set(libraries.filter(Boolean))];

            const payload = {
                libraryIds: uniqueLibraries,
                position: 1
            }

            return payload;
        }

        function getLibraryPositionsFromPreview(preview) {
            if (!preview) {
                return undefined;
            }

            const libraries = [];

            const elementTypeConfigs = [
                {
                    key: 'texts',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId', 'strokeColorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'circularTexts',
                    libraryIdKeys: ['outlineColorLibraryId', 'colorLibraryId', 'fontLibraryId']
                },
                {
                    key: 'imagePlaceHolders',
                    libraryIdKeys: ['imageLibraryId', 'colorLibraryId', 'shadowColorLibraryId']
                },
                {
                    key: 'vectorsEps',
                    libraryIdKeys: ['vectorLibraryId', 'colorLibraryId']
                }
            ];

            for (const config of elementTypeConfigs) {
                const elements = preview[config.key] || [];
                libraries.push(...extractLibraryIdsFromElements(elements, config.libraryIdKeys));
            }

            const uniqueLibraries = [...new Set(libraries.filter(Boolean))];

            const payload = {
                libraryIds: uniqueLibraries,
                position: 1
            }

            return payload;
        }

        return {
            getLibraries: getLibraries,
            getLibrariesCount: getLibrariesCount,
            getLibraryElementAtPosition: getLibraryElementAtPosition,
            getLibrariesElementAtPosition: getLibrariesElementAtPosition,
            getLibraryName: getLibraryName,

            clearCachedLibraries: clearCachedLibraries,
            getLibraryPositionsFromListEps: getLibraryPositionsFromListEps,
            getLibraryPositionsFromPreview: getLibraryPositionsFromPreview
        };
    }
})();
